import React, { useContext, useState } from "react";
import logo from "../assets/01pos.webp";
import { axiosInstance } from "../axiosInstance";
import { Link, useNavigate } from "react-router";
import { notify } from "../components/toastify";
import loader from "../assets/loader.webp";
import useRotatingImages from "../utility/useRotatingImages";
import { ProfileDetailsContext } from "../context/ProfileDetailsProvider";
import CalculateIcon from "@mui/icons-material/Calculate";
import Calculator from "../utility/Calculator";

function Login({ setIsAuthenticated, setUserRole }) {
  const { setProfileDetails } = useContext(ProfileDetailsContext);
  const currentImage = useRotatingImages(10000);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [login_pin, setLogin_pin] = useState("");
  const [passform, setPassform] = useState(false);
  const [loading, setLoading] = useState(false);
  const [calculator, setCalculator] = useState(false);
  const navigate = useNavigate();

  // Function to handle API POST request for login
  const postData = async (newData) => {
    setLoading(true); // Set loading to true before the API call
    try {
      const response = await axiosInstance.post("api/auth/login", newData);

      setProfileDetails(response?.data?.data);
      if (response.data.error === false) {
        notify(response?.data?.message, "success");
        const name = response?.data?.data?.user.roles[0]?.name;
        const { accessToken } = response?.data?.data;
        // sessionStorage.setItem("token", accessToken);

        // Testing my new idea here
        sessionStorage.setItem(
          "token",
          JSON.stringify({ accessToken, role: name })
        );

        setUserRole(name);

        if (name === "Super Admin") {
          sessionStorage.setItem("superadmin_token", accessToken);
          navigate("/superadmin");
          setIsAuthenticated(true);
          // setTimeout(() => {
          // }, 1000);
        } else if (name === "Admin") {
          sessionStorage.setItem("admin_token", accessToken);
          navigate("/admin");
          setIsAuthenticated(true);
        } else if (name === "Manager") {
          sessionStorage.setItem("manager_token", accessToken);
          navigate("/manager");
          setIsAuthenticated(true);
        } else if (name === "Cashier") {
          sessionStorage.setItem("cashier_token", accessToken);
          navigate("/cashier");
          setIsAuthenticated(true);
        } else if (name === "Supervisor") {
          sessionStorage.setItem("supervisor_token", accessToken);
          navigate("/supervisordashboard");
        }
      } else if (response.data.error === true) {
        notify(response?.data?.message);
      }
    } catch (err) {
      notify(err?.response?.data?.message || err.message);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    const newData = passform ? { login_pin } : { email, password };
    postData(newData);
  };

  const handlePassform = (state) => {
    setPassform(state);
  };

  return (
    <div
      className="relative w-full h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${currentImage})` }}
    >
      {calculator && <Calculator handleClose={setCalculator} />}
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black opacity-20 z-10"></div>
      <div className="flex justify-center relative items-center px-4 h-screen z-20">
        <div className="flex flex-col gap-6 px-6 py-8 w-full rounded-md mx-4 md:max-w-[550px] bg-white">
          <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
            <div className="flex justify-between items-center">
              <div>
                <img src={logo} alt="logo" className="w-24" />
                <h2 className="text-3xl font-semibold">Welcome to 01 POS</h2>
              </div>
              <CalculateIcon
                sx={{ fontSize: "50px" }}
                onClick={() => setCalculator(true)}
                className="cursor-pointer"
              />
            </div>

            {!passform && (
              <div className="flex flex-col gap-3">
                <div className="flex flex-col">
                  <label htmlFor="email">Email</label>
                  <input
                    className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none"
                    placeholder="Youremail@mail.com"
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="flex flex-col">
                  <label htmlFor="password">Password</label>
                  <input
                    className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none"
                    placeholder="Password"
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="flex justify-end">
                  <Link to="/resetpassword">
                    <button
                      type="button"
                      className="text-sm text-gray-950 hover:text-gray-800"
                    >
                      Forgot password?
                    </button>
                  </Link>
                </div>
              </div>
            )}

            {passform && (
              <div className="flex flex-col">
                <label htmlFor="passcode">Passcode</label>
                <input
                  className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none"
                  placeholder="Enter Passcode"
                  type="password"
                  id="passcode"
                  value={login_pin}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                    setLogin_pin(numericValue);
                  }}
                  required
                />
              </div>
            )}

            <button
              type="submit"
              className="text-lg font-semibold p-2 text-white rounded-lg bg-[#2f345d] w-full flex justify-center hover:bg-[#455093] transition-all"
            >
              {loading ? (
                <img src={loader} alt="lodr" className="w-8" />
              ) : (
                "Login"
              )}
            </button>
          </form>

          {!passform ? (
            <button
              onClick={() => handlePassform(true)}
              className="text-lg font-semibold p-2 rounded-lg border-red-500 border-2 flex items-center justify-center text-center text-red-500 transition-all cursor-pointer hover:bg-red-500 hover:text-white"
            >
              Login with Passcode instead
            </button>
          ) : (
            <button
              onClick={() => handlePassform(false)}
              className="text-lg font-semibold p-2 rounded-lg border-red-500 border-2 flex items-center justify-center text-center text-red-500 transition-all cursor-pointer hover:bg-red-500 hover:text-white"
            >
              Login with Email
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;
